<template>
  <section>
    <notifications></notifications>
    <sidebar-help
      :title="$route.meta.title"
      :items="guides"
      :loader="loader"
      :toggleSidebar="visibleSideBar"
      @closeSidebar="closeSidebar"
    />
    <base-header>
      <div class="row align-items-center pt-header">
        <div class="col-lg-4 col-md-4 col-sm-4 col-4 d-flex align-items-center">
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>
          <h1 class="title-view">{{ $route.meta.title }}</h1>
        </div>
        <div
          class="col-lg-8 col-md-8 col-sm-8 col-8 align-items-center text-right"
        >
          <div class="box-buttons">
            <div v-if="selectedRows.length > 0" class="d-inline-block">
              <base-button
                v-if="selectedRows.length > 0"
                type="outline-neutral"
                class="min-button btn-line-danger"
                @click="
                  bulkDeleteBookings(selectedRows, handleBulkDeleteBookings)
                "
              >
                <i class="flaticon-delete icon-no-margin"></i>
                <strong class="d-lg-block d-none">Delete</strong>
              </base-button>
            </div>

            <base-button
              type="primary"
              @click="$router.push('/reservations/new')"
              class="min-button ml-2"
            >
              <i class="flaticon-plus"></i> New
              <strong class="d-lg-block d-none ml-1">Reservation</strong>
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mb-5">
      <div class="main-buttons">
        <div class="row">
          <div
            class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 align-self-center mb-0"
          >
            <b-form-group class="mb-0">
              <b-input-group size="sm" class="input-search">
                <b-input-group-prepend class="pt-1 pl-1">
                  <i class="flaticon-bold-magnifier"></i>
                </b-input-group-prepend>
                <b-form-input
                  id="filter-input"
                  v-model.trim="simpleSearch"
                  v-on:input="applySimpleSearch"
                  type="search"
                  placeholder="Search Anything..."
                  class="border-none"
                ></b-form-input>

                <b-input-group-append class="pt-1 pb-0">
                  <b-button
                    variant="neutro"
                    v-b-toggle.toggleFilters
                    class="p-0"
                  >
                    <i class="flaticon-equalizer"></i
                  ></b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>

          <div
            class="col-xl-8 col-lg-8 col-md-6 col-sm-12 col-12 alinmov2 align-self-center"
          >
            <div class="box-buttons">
              <base-button
                type="outline-neutral"
                class="min-button no-mb mr-2"
                v-if="query"
                @click="resetSearchFilter()"
              >
                <i class="flaticon-eraser"></i>Reset Search
              </base-button>
              <base-dropdown
                menu-on-right
                class="nav-item"
                tag="li"
                title-tag="a"
                title-classes="btn min-button btn-outline-neutral mr-2"
                title="Actions"
              >
                <base-button slot="title" type="none" class="p-0 min-button">
                  <i class="flaticon-rec"></i>
                  <strong>Status</strong>
                </base-button>
                <div
                  class="dropdown-item"
                  @click="applyFilterByReservationStatus('SBC')"
                >
                  <i class="flaticon-remove text-rejected"></i> Cancelled
                </div>
                <div
                  class="dropdown-item"
                  @click="applyFilterByReservationStatus('JF')"
                >
                  <i class="flaticon-check text-completed"></i> Completed
                </div>
                <div
                  class="dropdown-item"
                  @click="applyFilterByReservationStatus('SC')"
                >
                  <i class="flaticon-bold-check-3 text-confirmed"></i>
                  Confirmed
                </div>
                <div
                  class="dropdown-item"
                  @click="applyFilterByReservationStatus('BI')"
                >
                  <i class="flaticon-time-left text-draft"></i> Draft
                </div>
                <div
                  class="dropdown-item"
                  @click="applyFilterByReservationStatus('DRR')"
                >
                  <i class="flaticon-user-4 text-warning"></i> Driver Rejected
                </div>

                <div
                  class="dropdown-item"
                  @click="applyFilterByReservationStatus('DA')"
                >
                  <i class="flaticon-user-3 text-warning"></i> Driver Accepted
                </div>

                <div
                  class="dropdown-item"
                  @click="applyFilterByReservationStatus('DSR')"
                >
                  <i class="flaticon-route-1 text-warning"></i> Driver Started
                  Trip
                </div>

                <div
                  class="dropdown-item"
                  @click="applyFilterByReservationStatus('DAP')"
                >
                  <i class="flaticon-location-pin text-warning"></i> Driver on
                  Location
                </div>
                <div
                  class="dropdown-item"
                  @click="applyFilterByReservationStatus('POB')"
                >
                  <i class="flaticon-electric-car text-warning"></i> POB
                </div>

                <div
                  class="dropdown-item"
                  @click="applyFilterByReservationStatus('NW')"
                >
                  <i class="flaticon-add text-new"></i> New
                </div>
                <div
                  class="dropdown-item"
                  @click="applyFilterByReservationStatus('NS')"
                >
                  <i class="flaticon-no-group text-no-show"></i> No Show
                </div>
                <div
                  class="dropdown-item"
                  @click="applyFilterByReservationStatus('RCF')"
                >
                  <i class="flaticon-bold-check-3 text-processing"></i>
                  Reconfirm
                </div>
              </base-dropdown>

              <base-button
                type="outline-neutral"
                class="min-button d-lg-inline-block d-none"
                v-b-toggle.toggleFilters
              >
                <i class="flaticon-equalizer"></i>Advanced Search
              </base-button>
            </div>
          </div>

          <div class="col-12 pt-2 text-right" v-if="activeFilter || sortBySync">
            <template v-if="activeFilter">
              <span><strong>Filtered by: </strong></span>

              <ul class="box-tags-filters">
                <li class="tags-filters" v-if="simpleSearch">
                  {{ simpleSearch }}
                </li>
                <li class="tags-filters" v-if="filters.booking_number != ''">
                  Reservation N°: {{ filters.booking_number }}
                </li>
                <li class="tags-filters" v-if="filters.date != ''">
                  Date Range: {{ filters.date }}
                </li>
                <li class="tags-filters" v-if="filters.invoice_number != ''">
                  Invoice N°:{{ filters.invoice_number }}
                </li>
                <li class="tags-filters" v-if="reservationStatus">
                  Status: {{ reservationStatus | statusMessage }}
                </li>
                <li class="tags-filters" v-if="customerFilter">
                  Customer: {{ customerFilter.first_name }}
                  {{ customerFilter.last_name }}
                </li>
                <li class="tags-filters" v-if="driverFilter">
                  Driver: {{ driverFilter.first_name }}
                  {{ driverFilter.last_name }}
                </li>
                <li class="tags-filters" v-if="branchFilter">
                  Destination: {{ branchFilter.name }}
                </li>
                <li class="tags-filters" v-if="filters.last_name != ''">
                  Passenger Last Name:{{ filters.last_name }}
                </li>
                <li class="tags-filters" v-if="filters.first_name != ''">
                  Passenger First Name: {{ filters.first_name }}
                </li>
                <li class="tags-filters" v-if="filters.booking_reference != ''">
                  Reservation Reference: {{ filters.booking_reference }}
                </li>
                <li class="tags-filters" v-if="filters.destination != ''">
                  Destination: {{ filters.destination }}
                </li>
                <li class="d-inline-block">
                  <span @click="resetSearchFilter()" class="curp"
                    ><i class="flaticon-cancel ml-2"></i
                  ></span>
                </li>
              </ul>
            </template>
            <template v-if="sortBySync">
              <span class="ml-3"><strong>Local Sorted by:</strong></span>
              <ul class="box-tags-filters">
                <li class="tags-filters">
                  {{ getSortName(sortBySync, sortDescSync) }}
                </li>
                <li class="d-inline-block">
                  <span @click="restartSortAction()" class="curp"
                    ><i class="flaticon-cancel ml-2"></i
                  ></span>
                </li>
              </ul>
            </template>
          </div>
        </div>

        <b-collapse id="toggleFilters" class="mt-2">
          <div class="filters-advanced forms">
            <div class="card pb-2">
              <div class="row">
                <div
                  class="col-lg-6 col-md-6 col-sm-4 col-12 align-self-center pb-4"
                >
                  <h4 class="underline mb-0">Filters</h4>
                </div>
                <div
                  class="col-lg-6 col-md-6 col-sm-8 col-12 text-right align-self-center pb-4"
                >
                  <base-button
                    type="outline-neutral"
                    class="min-button"
                    v-b-toggle.toggleFilters
                  >
                    <i class="flaticon-cancel"></i>
                    Close
                  </base-button>
                  <base-button
                    type="outline-neutral"
                    class="min-button"
                    @click="resetSearchFilter()"
                  >
                    <i class="flaticon-eraser"></i> Clear
                  </base-button>
                  <base-button
                    type="primary"
                    class="min-button mb-2"
                    @click="applyAdvancedSearch"
                  >
                    Apply
                  </base-button>
                </div>
              </div>
              <div class="row formsearch">
                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12">
                  <base-input
                    placeholder="Reservation Number"
                    v-model.trim="filters.booking_number"
                    id="search_number"
                    name="search_number"
                    label="Reservation N°"
                    type="search"
                  ></base-input>
                </div>

                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12">
                  <base-input label="Date Range">
                    <flat-pickr
                      slot-scope="{ focus, blur }"
                      @on-open="focus"
                      @on-close="blur"
                      :config="{
                        allowInput: true,
                        mode: 'range',
                        altFormat: 'd-M-Y',
                        altInput: true,
                        dateFormat: 'Y-m-d'
                      }"
                      class="input-custom"
                      placeholder="Select Date Range"
                      v-model.trim="filters.date"
                      id="search_date"
                      name="search_date"
                      type="search"
                    ></flat-pickr>
                  </base-input>
                </div>

                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12">
                  <base-input
                    placeholder="Invoice Number"
                    v-model.trim="filters.invoice_number"
                    id="search_invoice"
                    name="search_invoice"
                    label="Invoice Number"
                    type="search"
                  ></base-input>
                </div>

                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12">
                  <WSelect
                    filterable
                    remote
                    reserve-keyword
                    :remote-method="filterCustomer"
                    placeholder="Enter a customer"
                    v-model.trim="filters.customer"
                    id="search_customer"
                    name="search_customer"
                    label="Customer"
                    @change="populateCustomer"
                    clearable
                  >
                    <el-option
                      v-for="(customer, index) in optionsCustomer"
                      class="select-danger"
                      :value="customer._id"
                      :label="
                        `${
                          customer.company_name !== ''
                            ? customer.company_name
                            : `${customer.first_name} ${customer.last_name}`
                        }`
                      "
                      :key="index"
                    ></el-option>
                  </WSelect>
                </div>

                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12">
                  <WSelect
                    placeholder="Enter a Destination"
                    v-model.trim="destinationSlug"
                    id="search_branch"
                    name="search_branch"
                    filterable
                    remote
                    reserve-keyword
                    @change="selectDestination"
                    label="Destination"
                    clearable
                  >
                    <el-option
                      v-for="(item, index) in branchesOptions"
                      :value="item.slug"
                      :label="item.name"
                      :key="index"
                    ></el-option>
                  </WSelect>
                </div>

                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12">
                  <base-input
                    placeholder="Reservation Reference"
                    v-model.trim="filters.booking_reference"
                    id="search_Reference"
                    name="search_Reference"
                    label="Reservation Reference"
                    type="search"
                  ></base-input>
                </div>

                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12">
                  <base-input
                    placeholder="First Name"
                    v-model.trim="filters.first_name"
                    id="search_firstname"
                    name="search_firstname"
                    label="Passenger First Name"
                    type="search"
                  ></base-input>
                </div>

                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12">
                  <base-input
                    placeholder="Last Name"
                    v-model.trim="filters.last_name"
                    id="search_lastName"
                    name="search_lastName"
                    label="Passenger Last Name"
                    type="search"
                  ></base-input>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12">
                  <WSelect
                    placeholder="Enter a Driver"
                    v-model.trim="filters.driver"
                    id="search_driver"
                    name="search_driver"
                    filterable
                    remote
                    reserve-keyword
                    @change="selectDriver"
                    label="Driver"
                    clearable
                  >
                    <el-option
                      v-for="driver in drivers"
                      :value="driver._id"
                      :label="`${driver.first_name} ${driver.last_name}`"
                      :key="driver._id"
                    ></el-option>
                  </WSelect>
                </div>

                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12">
                  <base-input
                    placeholder="Fleet"
                    v-model.trim="filters.destination"
                    id="search_fleet"
                    name="search_fleet"
                    label="Fleet"
                    type="search"
                  ></base-input>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
      </div>

      <div class="box-table">
        <div class="row">
          <div
            class="col-xl-5 col-lg-7 col-md-12 col-sm-12 col-12 align-self-center order-lg-1 order-md-2 order-sm-2 order-2"
          >
            <b-form-group v-slot="{ ariaDescribedby }" class="mb-0">
              <b-form-radio-group
                id="radio-group-2"
                v-model="filterStatus"
                :aria-describedby="ariaDescribedby"
                name="radio-sub-component"
                button-variant="type-tab"
                buttons
                @change="filteredTab"
                class="buttons-rows"
              >
                <b-form-radio value="all">All</b-form-radio>
                <b-form-radio value="NW"
                  >New
                  <badge type="danger" class="square" v-if="numberNew > 0">{{
                    numberNew
                  }}</badge>
                </b-form-radio>

                <b-form-radio value="DUD"
                  >Driver Unassigned
                  <badge
                    type="danger"
                    class="square"
                    v-if="numberUnassigned > 0"
                    >{{ numberUnassigned }}</badge
                  ></b-form-radio
                >
                <b-form-radio value="DRR"
                  >Driver Rejected
                  <badge
                    type="danger"
                    class="square"
                    v-if="numberRejected > 0"
                    >{{ numberRejected }}</badge
                  >
                </b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </div>

          <div
            class="col-xl-7 col-lg-5 col-md-12 col-sm-12 col-12 order-lg-2 order-md-1 order-sm-1 order-1 text-right mb-xl-0 mb-2"
          >
            <div
              class="col-xl-7 col-lg-12 col-md-6 col-sm-8 col-12 ml-auto d-inline-block mb-xl-0 mb-2"
            >
              <b-form-group
                label="Sort"
                label-for="sort-by-select"
                label-cols-sm="2"
                label-align-sm="right"
                label-size="sm"
                v-slot="{ ariaDescribedby }"
                class="mb-0"
                size="sm"
              >
                <b-input-group>
                  <b-form-select
                    id="sort-by-select"
                    v-model="sortBy"
                    :options="sortOptions"
                    @change="applySortBy"
                    :aria-describedby="ariaDescribedby"
                    class="w-70"
                    size="sm"
                  >
                    <template #first>
                      <option value="">-- None --</option>
                    </template>
                  </b-form-select>

                  <b-form-select
                    v-model="sortDesc"
                    :disabled="!sortBy"
                    @change="applySortType"
                    :aria-describedby="ariaDescribedby"
                    class="w-30"
                    size="sm"
                  >
                    <option :value="'asc'">Asc</option>
                    <option :value="'desc'">Desc</option>
                  </b-form-select>
                </b-input-group>
              </b-form-group>
            </div>

            <div class="d-inline-block mr-2">
              <b-form-group v-slot="{ ariaDescribedbyview }" class="mb-0">
                <b-form-radio-group
                  id="btn-radios-view"
                  v-model="view"
                  :aria-describedby="ariaDescribedbyview"
                  name="radios-btn-default"
                  buttons
                  @change="changeViewCard"
                  class="mb-0"
                  button-variant="outline-neutral pc-3"
                >
                  <b-form-radio value="table"
                    ><i class="flaticon-two" title="View Table"></i
                  ></b-form-radio>
                  <b-form-radio value="card"
                    ><i class="flaticon-menu" title="View Card"></i
                  ></b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </div>

            <div class="d-inline-block mr-2">
              <el-tooltip
                content="Manage columns"
                placement="bottom"
                class="d-inline-flex"
              >
                <base-button
                  type="outline-neutral"
                  class="btn-icon-only mb-0"
                  @click="modalManageColumn = true"
                >
                  <i class="flaticon-bold-settings mr-0"></i>
                </base-button>
              </el-tooltip>
            </div>

            <div class="d-inline-block mr-2">
              <el-tooltip content="Export" placement="bottom">
                <base-dropdown
                  menu-on-right
                  class="nav-item"
                  tag="div"
                  title-tag="a"
                  title-classes="btn btn-outline-neutral btn-icon-only m-0 dropnocaret"
                  title="Export"
                >
                  <base-button slot="title" type="none" class="p-0 min-button">
                    <i class="flaticon-downloading-files mr-0 mt-1"></i>
                  </base-button>

                  <div
                    class="dropdown-item"
                    @click="download(selectedRows)"
                    v-if="selectedRows.length > 0"
                  >
                    Selected Records
                  </div>
                  <div class="dropdown-item" @click="download()">
                    All Records
                  </div>
                </base-dropdown>
              </el-tooltip>
            </div>

            <div class="d-inline-block">
              <el-tooltip content="Help" placement="bottom">
                <base-button
                  type="outline-neutral"
                  class="btn-icon-only mb-0"
                  @click="openSideBar"
                >
                  <i class="flaticon-question-1 f-16 mr-0"></i>
                </base-button>
              </el-tooltip>
            </div>
          </div>
        </div>
        <pagination-block
          :pageCount="responseReservations.pages"
          :total="responseReservations.count"
          :limit="limit"
          v-model="currentPage"
          @changePage="changePage"
          @nextPage="nextPaginations"
          @prevPage="previousPaginations"
          @changeLimit="changeLimit"
          position="bottom"
        ></pagination-block>

        <b-table
          hover
          :items="reservations"
          :fields="fields"
          :sort-by.sync="sortBySync"
          :sort-desc.sync="sortDescSync"
          selectable
          @row-selected="onRowSelected"
          select-mode="multi"
          ref="selectableTable"
          sort-icon-left
          responsive
          :filter="filterOne"
          show-empty
          empty-filtered-text="There are no records matching your request"
          empty-text="There are no records to show"
          :busy="isBusy"
          :tbody-transition-props="transProps"
          :stacked="cardview"
          :table-class="getTableClass(reservations)"
        >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template #head()="{ label, field: { key } }">
            <span v-if="key === 'selected'">
              <span
                @click="clearSelected"
                v-if="selectedRows.length == reservations.length"
                class="check-table selected"
              ></span>

              <span @click="selectAllRows" v-else class="check-table"></span>
            </span>
            <span v-else>{{ label }}</span>
          </template>
          <template #cell(selected)="{ rowSelected }">
            <template v-if="rowSelected">
              <span aria-hidden="true" class="check-table selected"></span>
            </template>
            <template v-else>
              <span aria-hidden="true" class="check-table"></span>
            </template>
          </template>

          <template #cell(booking_number)="data">
            <router-link :to="`/reservations/${data.item.reservation._id}`"
              >{{ data.item.reservation.booking_number }}

              <el-tooltip
                v-if="data.item.reservation.product"
                content="Experience"
                placement="bottom"
                ><i class="flaticon-package text-blue ml-1"></i
              ></el-tooltip>

              <el-popover
                placement="bottom"
                trigger="hover"
                width="300"
                class="curp d-inline-flex ml-1"
                v-if="
                  data.item.reservation.childSeatsCount > 0 &&
                    data.item.reservation.owner === 'admin' &&
                    data.item.reservation.status === 'NW'
                "
              >
                <div class="p-2">
                  <span>
                    <strong>
                      This reservation includes a request for a child seat(s):
                    </strong>

                    Please confirm the availability of the requested child
                    seat(s) and indicate if there are any additional charges.
                    <br />
                    <br />
                    By accepting this reservation, you confirm that you can
                    provide the requested number of child seats. If they are
                    unavailable, please reject the booking or contact our
                    customer support team for assistance.
                  </span>
                </div>

                <div slot="reference" class="d-flex text-warning">
                  <i class="flaticon-circle"></i>
                </div>
              </el-popover>
            </router-link>
          </template>

          <template #cell(reservationtype)="data">
            <span class="text-capitalize" v-if="data.item.reservation.product">
              Experience
            </span>

            <span class="text-capitalize" v-else>Private Transfer</span>
          </template>

          <template #cell(typeTransfer)="data">
            <span>{{ data.item.typeTransfer }}</span>
          </template>

          <template #cell(from)="data">
            <span class="multiline-3">{{ data.item.from }} </span>
          </template>

          <template #cell(to)="data">
            <span class="multiline-3"> {{ data.item.to }}</span>
          </template>

          <template #cell(customer)="data">
            <a
              :href="
                data.item.reservation.customer &&
                data.item.reservation.customer.relationship.type === 'supplier'
                  ? `/customers/${data.item.reservation.customer._id}`
                  : `/customers`
              "
              class="link-img-profile"
              target="_blank"
            >
              <div class="content">
                <span
                  class="role-table"
                  v-if="data.item.reservation.customer"
                  >{{
                    getCustomerType(
                      data.item.reservation.customer.type,
                      data.item.reservation.owner
                    )
                  }}</span
                >
                <span
                  class="username hide-data capitalize"
                  v-if="data.item.reservation.customer !== null"
                >
                  {{ getCustomerName(data.item.reservation.customer) }}
                  <img
                    src="~rhomtrip_assets/src/img/brand/icon-rhomtrip-150x158.png"
                    alt="Rhomtrip"
                    class="img-icon"
                    v-if="data.item.reservation.owner === 'admin'"
                /></span>
                <span v-else class="text-danger text-capitalize"
                  >Unassigned</span
                >
              </div>
            </a>
          </template>

          <template #cell(passenger)="data">
            <div
              class="d-flex align-items-center"
              @click.stop="toggleDetails(data.item, data.item.bookingNumber)"
            >
              <span>
                <i
                  class="flaticon-web-down-chevron mr-2 f-10"
                  v-if="!isRowExpanded(data.item)"
                ></i>
                <i
                  class="flaticon-web-up-chevron mr-2 f-10"
                  v-if="isRowExpanded(data.item)"
                ></i>
              </span>

              <span class="text-capitalize">
                {{
                  getPassenger(
                    data.item.reservation.passengers,
                    data.item.reservation.passengersCount
                  )
                }}
              </span>
            </div>
          </template>

          <template #row-details="data">
            <div class="table-toggle ml-4">
              <div
                class="card w-100"
                :class="{ max: data.item.reservation.passengersCount > 8 }"
              >
                <h2 class="subtitle mb-3">Pax</h2>
                <b-table
                  hover
                  :items="data.item.passengers"
                  :fields="
                    getHeaderPassengerTable(
                      fieldsPassengerViewTable,
                      data.item.reservation.type
                    )
                  "
                  sort-by.sync="fullname"
                  sort-desc.sync="true"
                  selectable
                  @row-selected="onRowSelected"
                  select-mode="multi"
                  ref="passengertable"
                  sort-icon-left
                  responsive
                  show-empty
                  empty-filtered-text="There are no records matching your request"
                  empty-text="There are no records to show"
                >
                  <template #cell(fullname)="data">
                    <span class="text-capitalize"
                      >{{ getTitleByGender(data.item.gender) }}
                      {{ data.item.firstName }}
                      {{ data.item.lastName }}
                    </span>

                    <span
                      class="badge-status badge-default mr-2"
                      v-if="data.item.primary"
                      >Primary</span
                    >
                  </template>

                  <template #cell(phone)="data">
                    <span v-if="data.item.phone">{{ data.item.phone }}</span>
                    <span v-else>N/A</span>
                  </template>

                  <template
                    #cell(email)="data"
                    v-if="data.item.reservation.owner != 'admin'"
                  >
                    <span class="hide-data lower" v-if="data.item.email">
                      {{ data.item.email }}
                    </span>
                    <span v-else> N/A</span>
                  </template>

                  <template #cell(itinerary)="data">
                    <span class="uppercase" v-if="data.item.flightNumber">{{
                      data.item.flightNumber
                    }}</span>
                    <span v-else>N/A</span>
                  </template>

                  <template #cell(type)="data">
                    {{ getPassengerType(data.item.type) }}
                  </template>

                  <template #cell(notify)="data">
                    {{ data.item.notify ? "Yes" : "No" }}
                  </template>

                  <template #cell(actions)="data">
                    <el-tooltip content="Copy data" placement="bottom">
                      <span
                        class="icon-action mr-2"
                        @click.stop="copyPassengerData(data.item)"
                      >
                        <i class="flaticon-copy text-black"></i>
                      </span>
                    </el-tooltip>
                  </template>
                </b-table>
              </div>
            </div>
          </template>

          <template #cell(paxNumber)="data">
            <div v-if="data.item.class === 'Transfers'">
              <span>{{ data.item.passengersCount }} </span>
            </div>
            <div v-else>
              <span v-html="getLabelPax(data.item.reservation.unitItems)">
              </span>
            </div>
          </template>

          <template #cell(service)="data">
            <div v-if="data.item.reservation.service">
              <div class="box-img-card">
                <div class="img-car">
                  <LazyImage
                    :src="
                      data.item.reservation.service.vehicle.information.image
                    "
                    imgClasses="img-fluid es-img-service-2"
                  />
                </div>

                <div class="content">
                  <span class="capitalize hide-data title">
                    {{
                      formatCategory(
                        data.item.reservation.service.vehicle.parameters
                          .category
                      )
                    }}
                  </span>

                  <span class="hide-data subtitle-1"
                    >{{
                      data.item.reservation.service.vehicle.parameters.name
                    }}
                    or Similar</span
                  >
                  <span class="hide-data subtitle-1">{{
                    formatVehicleType(
                      data.item.reservation.service.vehicle.parameters.type
                    )
                  }}</span>
                </div>
              </div>
            </div>
            <div v-else class="">
              <span>-</span>
            </div>
          </template>

          <template #cell(pickup_date)="data">
            <span>{{
              getPickupDate(data.item.reservation.pickup_date, formatDate)
            }}</span>
            <span class="d-block">{{
              getPickupTime(data.item.reservation.pickup_time, formatTime)
            }}</span>
          </template>

          <template #cell(passengersCount)="data">
            <span>{{ data.item.passengersCount }}</span>
          </template>

          <template #cell(transportRef)="data">
            <div v-if="data.item.reservation.type !== 'journey'">
              <span class="role-table">
                {{ getLabelTransport(data.item.reservation.type) }}
              </span>
              <span
                class="d-block"
                :class="{
                  uppercase:
                    data.item.reservation.type !== 'hourly' &&
                    getTransportReference(data.item.reservation)
                }"
              >
                {{ getTransportReference(data.item.reservation) || "-" }}
              </span>
            </div>

            <div v-else>
              <span>N/A</span>
            </div>
          </template>

          <template #cell(destination)="data">
            <a
              v-if="data.item.reservation.branch !== null"
              class="text-capitalize hide-data"
              :href="`/destinations//${data.item.reservation.branch._id}`"
              target="_blank"
              >{{ data.item.reservation.branch.name }}</a
            >
          </template>

          <template #cell(status)="data">
            <el-popover
              placement="top"
              trigger="hover"
              width="230"
              v-if="
                showPopover(
                  data.item.reservation.old_status,
                  data.item.reservation.status,
                  data.item.reservation.status_update,
                  data.item.reservation.owner
                )
              "
            >
              <span class="text-center d-block">{{
                getStatusMessage(
                  data.item.reservation.old_status,
                  data.item.reservation.status,
                  data.item.reservation.created_at,
                  data.item.reservation.status_update,
                  data.item.reservation.owner,
                  data.item.reservation.pickup_date,
                  data.item.reservation.branch.timezone
                )
              }}</span>

              <div
                slot="reference"
                class="badge-status"
                v-bind:class="
                  getStatusClass(
                    data.item.reservation.status,
                    data.item.reservation.status_update,
                    data.item.reservation.owner,
                    data.item.reservation.pickup_date,
                    data.item.reservation.branch.timezone
                  )
                "
              >
                {{
                  getLabelStatus(
                    data.item.reservation.status,
                    data.item.reservation.status_update
                  )
                }}
              </div>
            </el-popover>
            <div
              v-else
              class="badge-status"
              v-bind:class="
                statusValue(
                  data.item.reservation.status,
                  data.item.reservation.owner
                )
              "
            >
              {{
                getLabelStatus(
                  data.item.reservation.status,
                  data.item.reservation.status_update
                )
              }}
            </div>
          </template>
          <template #cell(driver)="data">
            <span
              v-if="data.item.reservation.driver == null"
              class="text-danger"
              >Unassigned</span
            >
            <span v-else
              >{{ data.item.reservation.driver.person.first_name }}
              {{ data.item.reservation.driver.person.last_name }}</span
            >
          </template>

          <template #cell(netprice)="data">
            <span :class="data.item.netprice < 0 ? 'loss-alert' : ''">
              {{ data.item.currency.symbol }}
              {{ data.item.netprice }}
              {{ data.item.currency.code }}</span
            >
          </template>

          <template #cell(grossprice)="data">
            <span :class="data.item.grossprice < 0 ? 'loss-alert' : ''">
              {{ data.item.currency.symbol }}
              {{ data.item.grossprice }}
              {{ data.item.currency.code }}</span
            >
          </template>

          <template #cell(netprofit)="data">
            <span :class="data.item.netprofit < 0 ? 'loss-alert' : ''">
              {{ data.item.currency.symbol }}
              {{ data.item.netprofit }}
              {{ data.item.currency.code }}</span
            >
          </template>

          <template #cell(totalcharge)="data">
            <span :class="data.item.totalcharge < 0 ? 'loss-alert' : ''">
              {{ data.item.currency.symbol }}
              {{ data.item.totalcharge }}
              {{ data.item.currency.code }}</span
            >
          </template>
          <template #cell(totalExtras)="data">
            <span :class="data.item.totalExtras < 0 ? 'loss-alert' : ''">
              {{ data.item.currency.symbol }}
              {{ data.item.totalExtras }}
              {{ data.item.currency.code }}</span
            >
          </template>
          <template #cell(totalDiscounts)="data">
            <span :class="data.item.totalDiscounts < 0 ? 'loss-alert' : ''">
              {{ data.item.currency.symbol }}
              {{ data.item.totalDiscounts }}
              {{ data.item.currency.code }}</span
            >
          </template>

          <template #cell(reservation_reference)="data">
            <span> {{ data.item.reservation_reference }}</span>
          </template>

          <template #cell(invoice)="data">
            <span>{{ data.item.invoice_n }} </span>
          </template>

          <template #cell(actions)="data">
            <div
              class="text-center d-flex align-items-center justify-content-center"
              click.stop
            >
              <div class="button-action mr-2">
                <el-tooltip
                  content="History"
                  placement="bottom"
                  class="d-inline-flex"
                >
                  <span
                    class="icon-action text-blue"
                    @click="
                      openReservationHistoryModal(
                        data.item.reservation._id,
                        data.item.reservation.booking_number
                      )
                    "
                  >
                    <i class="flaticon-wall-clock-1"> </i>
                  </span>
                </el-tooltip>
              </div>
              <div
                class="drop-action d-inline-block"
                v-if="
                  canShowActionItem(
                    data.item.reservation.status,
                    data.item.reservation.owner
                  )
                "
              >
                <base-dropdown
                  menu-on-right
                  class="nav-item"
                  tag="li"
                  title-tag="a"
                  title-classes="dropnocaret"
                  title="Actions"
                  :direction="getDirection(reservations, data.index)"
                >
                  <span slot="title"> <i class="flaticon-bold-kebab"></i></span>
                  <div
                    class="dropdown-item"
                    v-if="
                      canConfirmBooking(
                        data.item.reservation.status,
                        data.item.reservation.status_update,
                        data.item.reservation.owner
                      )
                    "
                    @click.stop="
                      confirmBooking(
                        data.item.reservation._id,
                        changeBookingStatus
                      )
                    "
                  >
                    <span class="icon-action">
                      <i class="flaticon-bold-check-3 text-success"> </i>
                      Confirm
                    </span>
                  </div>

                  <div
                    class="dropdown-item"
                    v-if="
                      canBeRejected(
                        data.item.reservation.status,
                        data.item.reservation.status_update,
                        data.item.reservation.owner
                      )
                    "
                    @click.stop="
                      changeStatusToRejectByReservationId(
                        data.item.reservation._id,
                        data.item.reservation.service
                      )
                    "
                  >
                    <span class="icon-action">
                      <i class="flaticon-warning-1 text-rejected"></i> Reject
                    </span>
                  </div>
                  <div
                    class="dropdown-item"
                    v-if="
                      canCancelBooking(
                        data.item.reservation.status,
                        data.item.reservation.owner
                      )
                    "
                    @click.stop="
                      cancelBooking(
                        data.item.reservation._id,
                        cancelBookingById
                      )
                    "
                  >
                    <span class="icon-action">
                      <i class="flaticon-remove text-rejected"></i> Cancel
                    </span>
                  </div>

                  <div
                    class="dropdown-item"
                    v-if="
                      canCompleteBooking(data.item.reservation.status) &&
                        calculateHoursDifference(
                          data.item.reservation.pickup_date,
                          data.item.reservation.branch.timezone
                        ) >= 12
                    "
                    @click.stop="
                      completeBooking(
                        data.item.reservation._id,
                        changeBookingStatus
                      )
                    "
                  >
                    <span class="icon-action">
                      <i class="flaticon-check text-completed"></i> Complete
                    </span>
                  </div>

                  <div
                    class="dropdown-item"
                    v-if="
                      canMarkBookingAsNoShow(data.item.reservation.status) &&
                        calculateHoursDifference(
                          data.item.reservation.pickup_date,
                          data.item.reservation.branch.timezone
                        ) >= 12
                    "
                    @click.stop="
                      noShowBooking(
                        data.item.reservation._id,
                        changeBookingStatus
                      )
                    "
                  >
                    <span class="icon-action">
                      <i class="flaticon-no-group text-no-show"></i> No Show
                    </span>
                  </div>

                  <div
                    class="dropdown-item"
                    v-if="
                      canResendBookingEmail(
                        data.item.reservation.status,
                        data.item.reservation.owner
                      )
                    "
                    @click="
                      resendBookingNotifications(
                        data.item.reservation._id,
                        handleResendBookingNotifications
                      )
                    "
                  >
                    <span class="icon-action">
                      <i class="flaticon-envelope text-orange"></i> Resend Email
                    </span>
                  </div>
                  <div
                    class="dropdown-item"
                    v-if="
                      canDeleteBooking(
                        data.item.reservation.status,
                        data.item.reservation.owner
                      )
                    "
                    @click.stop="
                      deleteBooking(
                        data.item.reservation._id,
                        deleteBookingById
                      )
                    "
                  >
                    <span class="icon-action">
                      <i class="flaticon-delete text-danger"></i>Delete
                    </span>
                  </div>
                </base-dropdown>
              </div>
            </div>
          </template>
        </b-table>

        <pagination-block
          :pageCount="responseReservations.pages"
          :total="responseReservations.count"
          v-model="currentPage"
          :limit="limit"
          @changePage="changePage"
          @nextPage="nextPaginations"
          @prevPage="previousPaginations"
          @changeLimit="changeLimit"
          position="bottom"
        ></pagination-block>
      </div>
    </div>
    <RejectedReservations
      :show="showRejectModal"
      :reservationId="reservationId"
      :currency="currency"
      @close="closeModalReject"
      @onReservationRejected="onReservationRejected"
    />

    <ReservationHistory
      :show="showReservationHistory"
      :tempReservationId="tempReservationId"
      :bookingNumber="tempBookingNumber"
      @close="closeReservationHistoryModal"
    />

    <ManageTableColumns
      :value="modalManageColumn"
      :fields="fields"
      :tableGridConfig="tableGridConfig"
      :madatories="['booking_number']"
      @saveColumns="saveColumnsInUserAccount"
      @closeTableGridModal="closeTableGridModal"
    />
  </section>
</template>

<script>
// @ is an alias to /src
import moment from "moment-timezone";
import { mapGetters, mapActions, mapMutations } from "vuex";
import endpoint from "../../Commons/Services/index";
import { Table, TableColumn } from "element-ui";
import Pusher from "pusher-js";
import { DropdownPlugin } from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import WSelect from "@/components/Select";
import lodash from "lodash";
import ReservationHistory from "../components/ReservationHistory.vue";
import RejectedReservations from "../components/Modals/RejectedReservations.vue";
import ManageTableColumns from "../../../components/ManageTableColumns.vue";
import TableGrid from "../../Commons/Utility/TableGrid";
import {
  bulkDeleteBookings,
  calculateHoursDifference,
  canCancelBooking,
  cancelBooking,
  canCompleteBooking,
  canConfirmBooking,
  canDeleteBooking,
  canMarkBookingAsNoShow,
  canResendBookingEmail,
  canShowActionItem,
  completeBooking,
  confirmBooking,
  deleteBooking,
  FIELDS_PASSENGER_VIEW_TABLE,
  isDeletableBySupplier,
  noShowBooking,
  resendBookingNotifications,
  getLabelTransport,
  getTransportReference
} from "../../../helpers/reservation.helpers";
import { goBack, unauthorizedAction } from "../../../helpers/commons.helpers";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};
export default {
  name: "Reservations",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    DropdownPlugin,
    WSelect: WSelect,
    flatPickr,
    ReservationHistory: ReservationHistory,
    RejectedReservations: RejectedReservations,
    ManageTableColumns: ManageTableColumns
  },
  watch: {
    sortDescSync: {
      handler: async function(current, old) {
        await this.changeSortDescSync(current);
      },
      deep: true
    },
    sortBySync: {
      handler: async function(current, old) {
        await this.changeSortByAsync(current);
      },
      deep: true
    },
    query: {
      handler: async function(current, old) {
        await this.changeQuery(current);
      },
      deep: true
    }
  },
  data() {
    return {
      role: JSON.parse(localStorage.getItem("es-login")).role,
      currentPage: 1,
      selectedRows: [],
      pusher: null,
      limit: 0,
      fields: [],
      filterOne: null,
      simpleSearch: "",
      filters: {
        booking_number: "",
        date: "",
        invoice_number: "",
        customer: "",
        driver: "",
        branch: [],
        last_name: "",
        first_name: "",
        booking_reference: "",
        destination: ""
      },
      options: {
        statusSearch: [
          { value: "SBC", label: "Cancelled" },
          { value: "JF", label: "Completed" },
          { value: "SC", label: "Confirmed" },
          { value: "BI", label: "Draft" },
          { value: "NW", label: "New" },
          { value: "SRB", label: "Rejected" }
        ]
      },
      customers: [],
      optionsCustomer: [],
      filterStatus: "all",
      activeFilter: false,
      isBusy: false,
      transProps: {
        name: "flip-list"
      },
      reservationStatus: "",
      query: "",
      queryTemp: "",
      customerFilter: null,
      driverFilter: null,
      branchFilter: null,
      numberNew: 0,
      numberRejected: 0,
      numberUnassigned: 0,
      sortBy: "",
      sortDesc: "desc",
      sortOptions: [
        {
          value: "booking_number",
          text: "Reservation N°"
        },
        {
          value: "pickup_date",
          text: "Date & Time"
        },
        {
          value: "invoice",
          text: "Invoice N°"
        },
        {
          value: "passenger",
          text: "Passenger"
        },
        {
          value: "status",
          text: "Status"
        },
        {
          value: "driver",
          text: "Driver"
        },
        {
          value: "fleet",
          text: "Fleet"
        },
        { value: "created_at", text: "Created At" }
      ],
      drivers: [],
      showRejectModal: false,
      reservationId: "",
      currency: {
        code: "",
        symbol: "",
        label: ""
      },
      branchesOptions: [],
      destinationSlug: "",
      showReservationHistory: false,
      tempReservationId: "",
      tempBookingNumber: "",
      cardview: false,
      view: "table",
      modalManageColumn: false,
      sortBySync: "",
      sortDescSync: false,
      tableGridConfig: TableGrid.reservations,
      expandedRow: null,
      fieldsPassengerViewTable: FIELDS_PASSENGER_VIEW_TABLE,
      visibleSideBar: false,
      guides: [],
      loader: false
    };
  },
  async created() {
    this.pusher = new Pusher(process.env.VUE_APP_PUSHER_API_KEY, {
      cluster: process.env.VUE_APP_PUSHER_CLUSTER
    });
    this.fields = this.populateFiles(this.moduleSettings);
    this.sortBySync = this.getSortBySync(this.moduleSettings);
    this.sortDescSync = this.getSortDescSync(this.moduleSettings);
    this.query = this.getQuery(this.moduleSettings);
    this.subscribe("reservations");
    this.getSesion();
    var bread = [
      {
        text: "Reservations",
        active: true,
        append: true
      }
    ];
    this.setItemsBread(bread);
    await this.getLimit();
    await this.initFilters(this.query);
    this.limit = this.paginationLimit;
    this.queryTemp = this.tempPagination.status
      ? this.tempPagination.queryTemp
      : "";
    this.filterStatus = this.tempPagination.status
      ? this.tempPagination.filteredTabStatus
      : "all";
    this.currentPage = this.tempPagination.status
      ? this.tempPagination.currentPage
      : 1;
    this.get(
      true,
      this.limit,
      this.currentPage,
      this.queryTemp ? this.queryTemp : this.query
    );
    await this.getMetadata(this.query);
    await this.initDataSelection();
  },
  methods: {
    canConfirmBooking,
    confirmBooking,
    canCancelBooking,
    cancelBooking,
    canCompleteBooking,
    completeBooking,
    canMarkBookingAsNoShow,
    noShowBooking,
    calculateHoursDifference,
    canResendBookingEmail,
    resendBookingNotifications,
    canDeleteBooking,
    deleteBooking,
    bulkDeleteBookings,
    canShowActionItem,
    getLabelTransport,
    getTransportReference,
    subscribe(event) {
      var channel = this.pusher.subscribe("rhombuss");
      channel.bind(event, async data => {
        if (["supplier", "supplier_access"].indexOf(this.sesion.role) > -1) {
          let owner = this.getOwner(this.sesion);
          if (data.owner === owner) {
            await this.get(
              false,
              this.limit,
              this.currentPage,
              this.filterStatus === "all" ? this.query : this.queryTemp
            );
            this.getMetadata(this.query);
            this.showNotify(data.action);
          }
        }
      });
    },
    async initDataSelection() {
      this.customers = await this.getCustomersOptions();
      this.optionsCustomer = this.customers;
      this.branchesOptions = await this.getBranchesOptionsToFilters(
        this.sesion.id
      );
      if (this.filters.customer) {
        this.populateCustomer(this.filters.customer);
      }

      if (this.filters.branch) {
        this.destinationSlug = this.getDestinationSlugByBranches(
          this.branchesOptions,
          this.filters.branch
        );
        this.populateDestination(this.filters.branch);
        this.drivers = await this.getDriversByBranches(this.filters.branch);
        if (this.filters.driver) {
          this.populateDriver(this.filters.driver);
        }
      }
      this.activeFilter = this.query ? true : false;
    },
    populateCustomer(customerId) {
      let customer = this.optionsCustomer.find(
        customer => customer._id === customerId
      );
      this.customerFilter = customer ? customer : null;
    },
    async populateDestination(branches = []) {
      if (branches.length) {
        let destination = this.branchesOptions.find(destination =>
          lodash.isEqual(destination.branches.sort(), branches.sort())
        );
        this.branchFilter = destination ? destination : null;
      } else {
        this.branchFilter = null;
      }
    },
    populateDriver(driverId) {
      if (driverId) {
        let driver = this.drivers.find(driver => driver._id === driverId);
        this.driverFilter = driver ? driver : null;
      }
    },
    addElementInQuery(query, key, value) {
      let searchParams = new URLSearchParams(query);
      if (searchParams.has(key)) {
        searchParams.set(key, value ? value.trim() : value);
      } else {
        searchParams.append(key, value ? value.trim() : value);
      }
      return searchParams.toString();
    },
    deleteItemInQuery(query, keys = []) {
      let searchParams = new URLSearchParams(query);
      keys.forEach(key => {
        if (searchParams.has(key)) {
          searchParams.delete(key);
        }
      });
      return searchParams.toString();
    },
    async filteredTab(value) {
      if (value === "all") {
        this.currentPage = 1;
        this.queryTemp = "";
        await this.get(true, this.limit, this.currentPage, this.query);
      } else if (value === "NW") {
        this.currentPage = 1;
        if (this.numberNew > 0) {
          this.queryTemp = this.addElementInQuery(this.query, "status", value);
          await this.filterByReservationStatus(this.queryTemp);
        } else {
          this.reservations = [];
        }
      } else if (value === "DRR") {
        this.currentPage = 1;
        if (this.numberRejected > 0) {
          this.queryTemp = this.addElementInQuery(this.query, "status", value);
          await this.filterByReservationStatus(this.queryTemp);
        } else {
          this.reservations = [];
        }
      } else {
        this.currentPage = 1;
        if (this.numberUnassigned > 0) {
          this.queryTemp = this.addElementInQuery(this.query, "driver", null);
          await this.filterByStatusPayment(this.queryTemp);
        } else {
          this.reservations = [];
        }
      }
    },
    deleteEmptyElements(query) {
      return query
        .toString()
        .split("&")
        .filter(element => {
          let [key, value] = element.split("=");
          return key && value ? true : false;
        })
        .join("&");
    },
    async applyAdvancedSearch() {
      this.filterStatus = "all";
      this.activeFilter = true;
      let searchParams = this.buildParams({
        ...Object.fromEntries(new URLSearchParams(this.query)),
        ...this.filters
      });
      this.query = this.deleteEmptyElements(searchParams.toString());
      this.setAdvancedSearch(this.query);
      await this.getMetadata(this.query);
      await this.get(true, this.limit, this.currentPage, this.query);
    },
    async filterByReservationStatus(query) {
      await this.get(true, this.limit, this.currentPage, query);
    },
    async filterByStatusPayment(query) {
      await this.get(true, this.limit, this.currentPage, query);
    },
    async applyFilterByReservationStatus(status) {
      this.filterStatus = "all";
      this.activeFilter = true;
      this.reservationStatus = status;
      this.query = this.addElementInQuery(this.query, "status", status);
      this.setAdvancedSearch(this.query);
      await this.getMetadata(this.query);
      await this.filterByReservationStatus(this.query);
    },
    async initFilters(query) {
      if (query) {
        let searchParams = new URLSearchParams(query);
        this.filters.booking_number = searchParams.has("booking_number")
          ? searchParams.get("booking_number")
          : "";
        this.filters.date = searchParams.has("date")
          ? searchParams.get("date")
          : "";
        this.filters.invoice_number = searchParams.has("invoice_number")
          ? searchParams.get("invoice_number")
          : "";
        this.filters.customer = searchParams.has("customer")
          ? searchParams.get("customer")
          : "";
        this.filters.branch = searchParams.has("branch")
          ? searchParams.getAll("branch")
          : [];
        this.filters.driver = searchParams.has("driver")
          ? searchParams.get("driver")
          : "";
        this.filters.last_name = searchParams.has("last_name")
          ? searchParams.get("last_name")
          : "";
        this.filters.first_name = searchParams.has("first_name")
          ? searchParams.get("first_name")
          : "";
        this.filters.booking_reference = searchParams.has("booking_reference")
          ? searchParams.get("booking_reference")
          : "";
        this.filters.destination = searchParams.has("destination")
          ? searchParams.get("destination")
          : "";
        this.simpleSearch = searchParams.has("search")
          ? searchParams.get("search")
          : "";
        this.reservationStatus = searchParams.has("status")
          ? searchParams.get("status")
          : "";
      }
    },
    async resetSearchFilter() {
      this.destinationSlug = "";
      (this.filters = {
        booking_number: "",
        date: "",
        invoice_number: "",
        customer: "",
        driver: "",
        branch: [],
        last_name: "",
        first_name: "",
        booking_reference: "",
        destination: ""
      }),
        (this.filterStatus = "all");
      this.activeFilter = false;
      this.query = "";
      this.currentPage = 1;
      this.simpleSearch = "";
      this.reservationStatus = "";
      this.customerFilter = null;
      this.driverFilter = null;
      this.setAdvancedSearch(this.query);
      await this.getMetadata(this.query);
      await this.get(true, this.limit, this.currentPage, this.query);
    },

    changeLimit(limit) {
      if (this.limit !== limit) {
        this.limit = limit;
        this.currentPage = 1;
        if (this.filterStatus === "all") {
          this.get(true, this.limit, this.currentPage, this.query);
        } else {
          this.get(true, this.limit, this.currentPage, this.queryTemp);
        }
      }
    },
    previousPaginations(page) {
      if (this.filterStatus === "all") {
        this.get(true, this.limit, page, this.query);
      } else {
        this.get(true, this.limit, page, this.queryTemp);
      }
    },
    nextPaginations(page) {
      if (this.filterStatus === "all") {
        this.get(true, this.limit, page, this.query);
      } else {
        this.get(true, this.limit, page, this.queryTemp);
      }
    },
    changePage(page) {
      if (this.filterStatus === "all") {
        this.get(true, this.limit, page, this.query);
      } else {
        this.get(true, this.limit, page, this.queryTemp);
      }
    },
    async download(reservations = []) {
      try {
        this.setLoad(true);
        let { data } = await endpoint.exports.services.exportCSVReservations(
          { reservations: reservations },
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          const url = window.URL.createObjectURL(new Blob([data.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `reservations.csv`);
          document.body.appendChild(link);
          link.click();
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The data was not download. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The data was not download. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    statusValue(status, owner) {
      if (status === "NW") {
        return owner === "admin" ? "status-new-es" : "status-new";
      } else if (status === "SC") {
        return "status-confirmed";
      } else if (["SCB", "SBC"].includes(status)) {
        return "status-cancelled";
      } else if (status === "SRB") {
        return "status-rejected";
      } else if (["DA", "DSR", "DAP", "POB"].includes(status)) {
        return "status-started";
      } else if (status === "JF") {
        return "status-completed";
      } else if (status === "NS") {
        return "status-noshow";
      } else if (status === "BI") {
        return "status-draft";
      } else if (status === "PNDG") {
        return "status-draft";
      } else {
        return {};
      }
    },
    handleError(error, message, title = "Error!") {
      if (error.response) {
        let { data } = error.response;
        if (data.code === 401) {
          let auth = unauthorizedAction(error);
          if (auth) {
            this.setSigOut(true);
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } else {
        this.$notify({
          type: "danger",
          title: title,
          message: message,
          icon: "flaticon-remove"
        });
      }
    },
    goToPreviousPage() {
      goBack(this);
    },
    getCustomerName(customer) {
      if (customer) {
        if (this.role !== "admin") {
          if (customer.relationship.type !== "admin") {
            if (customer.company_name !== "") {
              return customer.company_name;
            } else {
              return `${customer.first_name} ${customer.last_name}`;
            }
          } else {
            return "RhomTrip";
          }
        } else {
          if (customer.company_name !== "") {
            return customer.company_name;
          } else {
            return `${customer.first_name} ${customer.last_name}`;
          }
        }
      } else {
        return "";
      }
    },
    showNotify(action) {
      if (action === "deleted") {
        this.$notify({
          type: "success",
          title: "Deleted!",
          message: "The Reservation has been deleted",
          icon: "flaticon-check-3"
        });
      } else if (action === "canceled") {
        this.$notify({
          type: "success",
          title: "Cancelled!",
          message: "The Reservation has been cancelled",
          icon: "flaticon-check-3"
        });
      } else if (action === "created") {
        this.$notify({
          type: "success",
          title: "Success!",
          message: "The reservations has been created",
          icon: "flaticon-check-3"
        });
      }
    },
    getOwner(sesion) {
      return sesion.role === sesion.account_type.type
        ? sesion.id
        : sesion.account_type.owner;
    },
    getDifference(createdAt) {
      return moment(moment().format()).diff(
        moment(createdAt).format(),
        "hours",
        true
      );
    },
    onRowSelected(selectedRows = []) {
      try {
        this.selectedRows = selectedRows.map(rows => rows.reservation);
      } catch (error) {
        this.selectedRows = [];
      }
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    async get(loader, limit, page, query) {
      this.getReservations({
        loader: loader,
        limit: limit,
        page: page,
        query: query
      });
    },
    async applySimpleSearch(value) {
      this.activeFilter = true;
      if (value) {
        if (this.filterStatus === "all") {
          this.query = this.addElementInQuery(this.query, "search", value);
          await this.getMetadata(this.query);
          await this.get(true, this.limit, this.currentPage, this.query);
          this.setAdvancedSearch(this.query);
        } else {
          let query = this.addElementInQuery(this.queryTemp, "search", value);
          await this.get(true, this.limit, this.currentPage, query);
        }
      } else {
        this.query = this.deleteItemInQuery(this.query, ["search"]);
        await this.getMetadata(this.query);
        await this.get(true, this.limit, this.currentPage, this.query);
        this.setAdvancedSearch(this.query);
      }
    },
    filterCustomer(input = "") {
      if (input !== "" && input.length > 2) {
        this.optionsCustomer = this.customers.filter(customer => {
          let name = `${customer.first_name} ${customer.last_name}`;
          return (
            name.toLowerCase().indexOf(input.toLowerCase()) > -1 ||
            customer.last_name.toLowerCase().indexOf(input.toLowerCase()) >
              -1 ||
            customer.first_name.toLowerCase().indexOf(input.toLowerCase()) >
              -1 ||
            customer.company_name.toLowerCase().indexOf(input.toLowerCase()) >
              -1
          );
        });
      } else {
        this.optionsCustomer = [];
      }
    },
    async getCustomersOptions() {
      try {
        let { data } = await endpoint.customers.services.customerOptions(
          this.sesion.token
        );
        if (data.status) {
          return data.data;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    async getMetadata(query) {
      try {
        let {
          data
        } = await endpoint.reservations.services.getMetadataReservations(
          query,
          this.sesion.token
        );
        if (data.status) {
          let metadata = data.data;
          this.numberNew = metadata.new;
          this.numberRejected = metadata.rejected;
          this.numberUnassigned = metadata.unassigned;
        } else {
          this.numberNew = 0;
          this.numberRejected = 0;
          this.numberUnassigned = 0;
        }
      } catch (error) {
        this.numberNew = 0;
        this.numberRejected = 0;
        this.numberUnassigned = 0;
      }
    },
    async applySortBy(value) {
      if (this.filterStatus === "all") {
        this.query = this.addElementInQuery(this.query, "sortBy", value);
        this.query = this.addElementInQuery(
          this.query,
          "sortType",
          this.sortDesc
        );
        await this.get(true, this.limit, this.currentPage, this.query);
      } else {
        this.queryTemp = this.addElementInQuery(
          this.queryTemp,
          "sortBy",
          value
        );
        this.queryTemp = this.addElementInQuery(
          this.queryTemp,
          "sortType",
          this.sortDesc
        );
        await this.get(true, this.limit, this.currentPage, this.queryTemp);
      }
    },
    async applySortType(value) {
      if (this.filterStatus === "all") {
        this.query = this.addElementInQuery(this.query, "sortType", value);
        await this.get(true, this.limit, this.currentPage, this.query);
      } else {
        this.queryTemp = this.addElementInQuery(
          this.queryTemp,
          "sortType",
          value
        );
        await this.get(true, this.limit, this.currentPage, this.queryTemp);
      }
    },
    async getDriversByBranches(branches = []) {
      try {
        let { data } = await endpoint.drivers.services.getDriversByBranches(
          branches,
          this.sesion.token
        );
        if (data.status) {
          return data.data;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    canBeRejected(status, statusUpdate, owner) {
      let values = [
        "SC",
        "SBC",
        "SCB",
        "NS",
        "JF",
        "DA",
        "SRB",
        "POB",
        "DAP",
        "DSR",
        "DRR"
      ];
      if (owner === "admin") {
        if (statusUpdate && status === "SC") {
          return true;
        } else {
          return !values.includes(status);
        }
      } else {
        return false;
      }
    },
    getDirection: function(reservations = [], index) {
      if (reservations.length >= 5) {
        let position = reservations.length - index;
        if (position === 5) {
          return "down";
        } else {
          return position > 5 ? "down" : "up";
        }
      } else {
        return "down";
      }
    },
    getTableClass(reservations = []) {
      return reservations.length < 5 ? "b-table-separator" : "";
    },
    closeModalReject(status) {
      this.showRejectModal = status;
    },
    changeStatusToRejectByReservationId(reservationId, service) {
      this.reservationId = reservationId;
      this.showRejectModal = true;
      this.currency = {
        code: service.currency_code,
        symbol: service.currency_symbol,
        label: service.currency_label
      };
    },
    async onReservationRejected(status) {
      if (status) {
        await this.get(
          true,
          this.limit,
          this.currentPage,
          this.queryTemp ? this.queryTemp : this.query
        );
      }
    },
    getCustomerType(type, owner) {
      if (owner !== "admin") {
        if (type === "admin") {
          return "Admin";
        } else if (type === "driver") {
          return "Driver";
        } else if (type === "suppliers") {
          return "Supplier";
        } else if (type === "customer") {
          return "Customer";
        } else if (type === "ote") {
          return "OTE";
        } else if (type === "travel_agency") {
          return "Travel Agency";
        } else if (type === "business") {
          return "Business";
        } else if (type === "guest") {
          return "Guest";
        } else {
          return "Client";
        }
      } else {
        return "Customer";
      }
    },
    async selectDestination(destinationSlug) {
      if (destinationSlug) {
        let destination = this.branchesOptions.find(
          destination => destination.slug === destinationSlug
        );
        if (destination) {
          this.branchFilter = destination;
          this.filters.branch = destination.branches;
          this.drivers = await this.getDriversByBranches(this.filters.branch);
        } else {
          this.branchFilter = null;
          this.drivers = [];
        }
      } else {
        this.branchFilter = null;
        this.filters.driver = "";
        this.drivers = [];
      }
    },
    async selectDriver(driverId) {
      if (driverId) {
        let driver = this.drivers.find(driver => driver._id === driverId);
        this.driverFilter = driver ? driver : null;
      } else {
        this.driverFilter = null;
      }
    },
    async getBranchesOptionsToFilters(operatorId) {
      try {
        let {
          data
        } = await endpoint.branches.services.getBranchesOptionsToFilters(
          operatorId,
          this.sesion.token
        );
        if (data.status) {
          return data.data;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    buildParams(data) {
      const params = new URLSearchParams();
      Object.entries(data).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach(value => params.append(key, value.toString()));
        } else {
          params.append(key, value.toString());
        }
      });
      return params.toString();
    },
    getDestinationSlugByBranches(destinations = [], branches = []) {
      let destination = destinations.find(destination => {
        return lodash.isEqual(destination.branches.sort(), branches.sort());
      });
      if (destination) {
        return destination.slug;
      } else {
        return "";
      }
    },
    openReservationHistoryModal(reservationId, bookingNumber) {
      this.tempReservationId = reservationId;
      this.tempBookingNumber = bookingNumber;
      this.showReservationHistory = true;
    },
    closeReservationHistoryModal() {
      this.showReservationHistory = false;
    },
    changeViewCard() {
      if (this.view === "table") {
        this.cardview = false;
      } else {
        this.cardview = true;
      }
    },
    getPassenger(passengers = [], passengersCount) {
      if (!lodash.isEmpty(passengers)) {
        let [passenger] =
          passengers.filter(passenger => passenger.primary) || passengers;
        if (passenger) {
          return `${passenger.fullName} ${
            passengersCount === 1 ? "" : `+ ${passengersCount - 1}`
          }`;
        }
      }
      return "Unassigned";
    },
    getStatusMessage(
      oldStatus,
      currentstatus,
      createdAt,
      statusUpdate,
      owner,
      pickupDate,
      timeZone
    ) {
      let cutOff = this.isWithin72Hours(pickupDate, timeZone);
      if (currentstatus === "NW") {
        if (owner === "admin") {
          if (cutOff) {
            return `This reservation is ${this.hoursUntil(
              pickupDate,
              timeZone
            )} away from the pickup date and still needs to be confirmed.`;
          } else {
            let diff = this.getDifference(createdAt) >= 48;
            return diff
              ? `This reservation is not yet confirmed, ${this.getCounterTime(
                  createdAt
                )} have passed since it was assigned.`
              : "This reservation requires confirmation.";
          }
        } else {
          return statusUpdate
            ? "This reservation has been updated but is not yet confirmed."
            : "";
        }
      } else if (currentstatus === "PNDG") {
        return ".";
      } else {
        if (currentstatus === "SC") {
          return statusUpdate
            ? "This reservation has been updated and needs to be reconfirmed."
            : "";
        } else {
          return "";
        }
      }
    },
    getStatusClass(currentstatus, statusUpdate, owner, pickupDate, timeZone) {
      if (currentstatus === "NW") {
        if (owner === "admin") {
          let cutOff = this.isWithin72Hours(pickupDate, timeZone);
          return cutOff ? "status-new critical-new" : "status-new";
        } else {
          return statusUpdate ? "status-reconfirm" : "status-new";
        }
      } else if (currentstatus === "SC") {
        return statusUpdate ? "status-reconfirm" : "status-confirmed";
      } else if (["SCB", "SBC"].includes(currentstatus)) {
        return "status-cancelled";
      } else if (currentstatus === "SRB") {
        return "status-rejected";
      } else if (["DA", "DSR", "DAP", "POB"].includes(currentstatus)) {
        return "status-started";
      } else if (currentstatus === "JF") {
        return "status-completed";
      } else if (currentstatus === "NS") {
        return "status-noshow";
      } else if (currentstatus === "BI") {
        return "status-draft";
      } else if (currentstatus === "DRR") {
        return "status-rejected";
      } else {
        return {};
      }
    },
    showPopover(oldStatus, currentStatus, statusUpdate, owner) {
      if (currentStatus === "NW") {
        if (owner === "admin") {
          return true;
        } else {
          return statusUpdate ? true : false;
        }
      } else if (currentStatus === "PNDG") {
        return true;
      } else if (currentStatus === "SC") {
        return statusUpdate;
      } else if (currentStatus === "SRB") {
        return false;
      } else {
        return false;
      }
    },
    getLabelStatus(status, statusUpdate) {
      if (status === "SC") {
        if (statusUpdate) {
          return "Reconfirm";
        } else {
          return this.getReservationStatus(status);
        }
      } else {
        return this.getReservationStatus(status);
      }
    },
    getReservationStatus(status) {
      if (status === "NW") {
        return "New";
      } else if (["SBC", "SCB"].includes(status)) {
        return "Cancelled";
      } else if (status === "SC") {
        return "Confirmed";
      } else if (status === "JF") {
        return "Completed";
      } else if (status === "SRB") {
        return "Rejected";
      } else if (status === "DA") {
        return "Driver Accepted";
      } else if (status === "DSR") {
        return "Driver Started Trip";
      } else if (status === "DAP") {
        return "Driver on Location";
      } else if (status === "POB") {
        return "POB";
      } else if (status === "NS") {
        return "No Show";
      } else if (status === "DRR") {
        return "Driver Rejected";
      } else if (status === "RCF") {
        return "Reconfirm";
      } else {
        return "Draft";
      }
    },
    getCounterTime(createdAt) {
      let hours = this.getDifference(createdAt);
      const totalMinutes = Math.floor(hours * 60);
      const days = Math.floor(totalMinutes / (60 * 24));
      const hoursRemaining = Math.floor((totalMinutes % (60 * 24)) / 60);
      let result = "";
      if (days === 1) {
        result += `${days} day `;
      } else if (days > 1) {
        result += `${days} days `;
      }
      if (hoursRemaining === 1) {
        result += `${hoursRemaining} hour `;
      } else if (hoursRemaining > 1) {
        result += `${hoursRemaining} hours `;
      }
      return result.trim();
    },
    isWithin72Hours(pickupDate, timeZone) {
      let currentDate = moment.tz(timeZone).utc(true);
      let thresholdDate = moment(pickupDate).subtract(72, "hours");
      return (
        currentDate.isAfter(thresholdDate) && currentDate.isBefore(pickupDate)
      );
    },
    hoursUntil(pickupDate, timeZone) {
      let currentDate = moment.tz(timeZone).utc(true);
      let duration = moment.duration(moment(pickupDate).diff(currentDate));
      let hours = Math.floor(duration.asHours());
      const totalMinutes = Math.floor(hours * 60);
      const days = Math.floor(totalMinutes / (60 * 24));
      const hoursRemaining = Math.floor((totalMinutes % (60 * 24)) / 60);
      let result = "";
      if (days === 1) {
        result += `${days} day `;
      } else if (days > 1) {
        result += `${days} days `;
      }
      if (hoursRemaining === 1) {
        result += `${hoursRemaining} hour `;
      } else if (hoursRemaining > 1) {
        result += `${hoursRemaining} hours `;
      }
      return result.trim();
    },
    closeTableGridModal(status) {
      this.modalManageColumn = status;
    },
    async saveColumnsInUserAccount(fields = []) {
      this.modalManageColumn = false;
      this.fields = fields;
      let { status, settings } = await this.updateSettingLayoutsByUserId(
        this.sesion.id,
        { "settings.reservations.tableLayouts": this.fields }
      );
      if (status) {
        this.$notify({
          type: "success",
          title: "Success!",
          message: "Columns have been changed",
          icon: "flaticon-check-3"
        });
        this.setModuleSettings(settings);
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "Columns haven't been changed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    async updateSettingLayoutsByUserId(userId, payload) {
      try {
        let {
          data
        } = await endpoint.settings.services.updateSettingLayoutsByUserId(
          userId,
          payload,
          this.sesion.token
        );
        if (data.status) {
          return { status: true, settings: data.data.settings };
        } else {
          return { status: false, settings: null };
        }
      } catch (error) {
        return { status: false, settings: null };
      }
    },
    populateFiles(settings) {
      try {
        if (settings) {
          if (settings.reservations.tableLayouts.length > 0) {
            return settings.reservations.tableLayouts;
          } else {
            return TableGrid.reservations.filter(option => {
              return option.settings.default;
            });
          }
        } else {
          return TableGrid.reservations.filter(option => {
            return option.settings.default;
          });
        }
      } catch (error) {
        return TableGrid.reservations.filter(option => {
          return option.settings.default;
        });
      }
    },
    getSortBySync(settings) {
      try {
        if (settings) {
          if (settings.reservations.sortBySync) {
            return settings.reservations.sortBySync;
          } else {
            return "";
          }
        } else {
          return "";
        }
      } catch (error) {
        return "";
      }
    },
    getQuery(settings) {
      try {
        if (settings) {
          if (settings.reservations.query) {
            return settings.reservations.query;
          } else {
            return "";
          }
        } else {
          return "";
        }
      } catch (error) {
        return "";
      }
    },
    async changeSortByAsync(sortBySync) {
      let { status, settings } = await this.updateSettingLayoutsByUserId(
        this.sesion.id,
        { "settings.reservations.sortBySync": sortBySync }
      );
      if (status) {
        this.setModuleSettings(settings);
      }
    },
    async changeQuery(query) {
      let { status, settings } = await this.updateSettingLayoutsByUserId(
        this.sesion.id,
        { "settings.reservations.query": query }
      );
      if (status) {
        this.setModuleSettings(settings);
      }
    },
    getSortDescSync(settings) {
      try {
        if (settings) {
          if (settings.reservations.sortBySync) {
            return settings.reservations.sortDescSync;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    },
    async changeSortDescSync(sortDescSync) {
      let { status, settings } = await this.updateSettingLayoutsByUserId(
        this.sesion.id,
        { "settings.reservations.sortDescSync": sortDescSync }
      );
      if (status) {
        this.setModuleSettings(settings);
      }
    },
    getPickupDate(date, formatDate) {
      return moment
        .parseZone(date)
        .utc(true)
        .format(formatDate);
    },
    getPickupTime(time, formatTime) {
      return moment(time, ["hh:mm A"]).format(formatTime);
    },
    getPriceFormat(price) {
      return parseFloat(price.toFixed(2));
    },
    formatStatus(status) {
      if (status === "NW") {
        return "New";
      } else if (status === "SBC" || status === "SCB") {
        return "Cancelled";
      } else if (status === "SC") {
        return "Confirmed";
      } else if (status === "JF") {
        return "Completed";
      } else if (status === "SRB") {
        return "Rejected";
      } else if (status === "DA") {
        return "Driver Accepted";
      } else if (status === "DSR") {
        return "Driver Started Trip";
      } else if (status === "DAP") {
        return "Driver on Location";
      } else if (status === "POB") {
        return "POB";
      } else if (status === "NS") {
        return "No Show";
      } else if (status === "PNDG") {
        return "Pending";
      } else {
        return "Draft";
      }
    },
    getAmountByOwner(salePrice, netPrice, owner) {
      return owner === "supplier"
        ? this.getPriceFormat(salePrice)
        : this.getPriceFormat(netPrice);
    },
    restartSortAction() {
      this.sortBySync = "";
      this.sortDescSync = false;
    },
    getSortName(sortBy, sortDesc) {
      let sort = this.fields.find(option => option.key === sortBy);
      if (sort) {
        return `${sort.label} - ${sortDesc ? "Descending" : "Ascending"}`;
      } else {
        return "None";
      }
    },
    getReservationTypes(type) {
      if (type === "arrival") {
        return "Airport (Arrival)";
      } else if (type === "departure") {
        return "Airport (Departure)";
      } else if (type === "station") {
        return "Train";
      } else if (type === "port") {
        return "Port";
      } else if (type === "hourly") {
        return "Hourly";
      } else {
        return "Journey";
      }
    },
    getTitleByGender(gender) {
      if (gender === "male") {
        return "Mr.";
      } else if (gender === "female") {
        return "Mrs.";
      } else {
        return "Mx.";
      }
    },
    getPassengerType(type) {
      if (type === "ADULT") {
        return "Adult";
      } else if (type === "SENIOR") {
        return "Senior";
      } else {
        return "Child";
      }
    },
    toggleDetails(item, id) {
      if (item["_showDetails"]) item["_showDetails"] = false;
      else this.$set(item, "_showDetails", true);
      this.expandedRow =
        this.expandedRow === item.booking_number ? null : item.booking_number;
    },
    isRowExpanded(item) {
      return item._showDetails && this.expandedRow === item.booking_number;
    },
    getHeaderPassengerTable(files = [], transferType) {
      return files
        .filter(file => {
          if (["hourly", "journey"].includes(transferType)) {
            return file.key !== "itinerary";
          } else {
            return true;
          }
        })
        .map(file => {
          if (file.key === "itinerary") {
            file.label = this.getLabelToHeaderTable(transferType);
          }
          return file;
        });
    },
    getLabelToHeaderTable(type) {
      if (["airport", "arrival", "departure"].indexOf(type) > -1) {
        return "Flight N°";
      } else if (type === "station") {
        return "Rail Line";
      } else if (type === "port") {
        return "Cruise Ship";
      } else {
        return "Transport Ref.";
      }
    },
    async copyPassengerData(passenger) {
      try {
        let text = `Name: ${passenger.fullName}\nPhone: ${passenger.phone}`;
        let clipboard = await navigator.clipboard.writeText(text);
        this.$notify({
          type: "success",
          title: "Success!",
          message: "The data has been copied to the clipboard",
          icon: "flaticon-check-3"
        });
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation could not be completed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    formatVehicleType(type) {
      if (type === "sedan") {
        return "Sedan";
      } else if (type === "boat") {
        return "Boat";
      } else if (type === "coach") {
        return "Coach";
      } else if (type === "limousine") {
        return "Limousine";
      } else if (type === "minibus") {
        return "Minibus";
      } else if (type === "midicoach") {
        return "Midicoach";
      } else if (type === "minivan") {
        return "Minivan";
      } else if (type === "mpv") {
        return "Mpv";
      } else if (type === "pickup") {
        return "Pickup";
      } else if (type === "premium_sedans") {
        return "Premium Sedans";
      } else if (type === "suvs") {
        return "SUVs";
      }
    },
    formatCategory(type) {
      if (type === "standard") {
        return "Standard Class";
      } else if (type === "business") {
        return "Business Class";
      } else {
        return "Luxury Class";
      }
    },
    async openSideBar() {
      this.visibleSideBar = true;
      this.loader = true;
      this.guides = await this.getSupportDocuments("SUPPLIERS", "RESERVATIONS");
      this.loader = false;
    },
    closeSidebar(status) {
      this.visibleSideBar = status;
    },
    async getSupportDocuments(app, module) {
      try {
        let { data } = await endpoint.documents.services.getSupportDocuments(
          app,
          module,
          this.sesion.token
        );
        if (data.status) {
          return data.data;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    /**
     * Booking Actions
     */
    async cancelBookingById(bookingId, reason, refundEligibility) {
      try {
        this.setLoad(true);
        let {
          data
        } = await endpoint.reservations.services.canlcelReservationById(
          bookingId,
          reason,
          refundEligibility,
          this.sesion.token
        );
        this.setLoad(false);
        let { canceled } = data.data;
        if (!canceled) {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Reservation can't be Cancelled",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(error, "The Reservation can't be cancelled");
      }
    },
    async changeBookingStatus(bookingId, status, reason = "") {
      try {
        this.setLoad(true);
        let {
          data
        } = await endpoint.reservations.services.changeRservationStatus(
          bookingId,
          status,
          reason,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          await this.get(
            true,
            this.limit,
            this.currentPage,
            this.queryTemp ? this.queryTemp : this.query
          );
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The reservation have been completed successfully",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The reservation could not be completed",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    handleResendBookingNotifications(bookingId, recipients = []) {
      if (recipients.length > 0) {
        this.resendBookingNotificationsById(bookingId, recipients);
      } else {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "No notification was sent, you must select a recipient",
          icon: "flaticon-warning-1"
        });
      }
    },
    async resendBookingNotificationsById(bookingId, recipients) {
      try {
        this.setLoad(true);
        let {
          data
        } = await endpoint.reservations.services.resendEmailToUsersByReservationId(
          bookingId,
          recipients,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The notifications have been forwarded successfully",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The notifications couldn't be sent",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The operation couldn't be completed. Please try again"
        );
      }
    },
    async deleteBookingById(bookingId) {
      try {
        this.setLoad(true);
        let { data } = await endpoint.reservations.services.deleteReservation(
          bookingId,
          this.sesion.token
        );
        this.setLoad(false);
        if (!data.status) {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Reservation cannot be Deleted!",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    handleBulkDeleteBookings(bookings = []) {
      let isDeletable = isDeletableBySupplier(bookings);
      if (!isDeletable) {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "One or more reservations do not belong to you",
          icon: "flaticon-warning-1"
        });
        return;
      }
      this.bulkDeleteBookingsByIds(bookings);
    },
    async bulkDeleteBookingsByIds(bookings = []) {
      try {
        this.setLoad(true);
        let {
          data
        } = await endpoint.reservations.services.deleteReservationMany(
          bookings,
          this.sesion.token
        );
        this.setLoad(false);
        if (!data.status) {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Reservations cannot be Deleted!",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    ...mapActions(["getReservations", "getSesion", "getLimit"]),
    ...mapMutations([
      "setLoad",
      "setSigOut",
      "setItemsBread",
      "setSesion",
      "setSettings",
      "setAdvancedSearch",
      "setTempPagination",
      "setModuleSettings"
    ])
  },
  destroyed() {
    if (this.pusher !== null) {
      this.pusher.disconnect();
    }
  },
  computed: {
    ...mapGetters([
      "responseReservations",
      "sesion",
      "load",
      "settings",
      "itemsBread",
      "advancedSearch",
      "paginationLimit",
      "tempPagination",
      "moduleSettings"
    ]),
    formatDate: function() {
      return this.settings ? this.settings.dateFormat : "DD-MMM-YYYY";
    },
    formatTime: function() {
      return this.settings ? this.settings.timeFormat : "hh:mm A";
    },
    reservations: function() {
      try {
        let reservations = this.responseReservations.docs || [];
        return reservations.map(reservation => {
          return {
            booking_number: reservation.booking_number,
            customer: this.getCustomerName(reservation.customer),
            passengers: reservation.passengers,
            passenger: this.getPassenger(
              reservation.passengers,
              reservation.passengersCount
            ),
            pickup_date: reservation.pickup_date,
            destination: reservation.branch.name,
            status: this.formatStatus(reservation.status),
            totalcharge: this.getAmountByOwner(
              reservation.pricing.totals.gross_price,
              reservation.pricing.totals.net_price,
              reservation.owner
            ),
            netprice: this.getAmountByOwner(
              reservation.pricing.totals.net_price,
              reservation.pricing.totals.net_price,
              reservation.owner
            ),
            grossprice: this.getAmountByOwner(
              reservation.pricing.totals.gross_price,
              reservation.pricing.totals.net_price,
              reservation.owner
            ),
            netprofit: this.getAmountByOwner(
              reservation.pricing.totals.net_profit,
              reservation.pricing.totals.net_price,
              reservation.owner
            ),
            totalExtras: this.getAmountByOwner(
              reservation.pricing.totals.extras.gross_price,
              reservation.pricing.totals.extras.net_price,
              reservation.owner
            ),
            totalDiscounts: this.getAmountByOwner(
              reservation.pricing.totals.discounts,
              0,
              reservation.owner
            ),
            reservation_reference: reservation.booking_reference,
            invoice_n: reservation.invoice_number,
            driver: reservation.driver
              ? `${reservation.driver.person.first_name} ${reservation.driver.person.last_name}`
              : null,
            currency: {
              code: reservation.service
                ? reservation.service.currency_code
                : "",
              symbol: reservation.service
                ? reservation.service.currency_symbol
                : ""
            },
            to: reservation.to,
            from: reservation.from,
            typeTransfer: this.getReservationTypes(reservation.type),
            passengersCount: reservation.passengersCount,
            flightNumber: reservation.flight_number,
            source: reservation.owner,
            reservation: reservation
          };
        });
      } catch (error) {
        return [];
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    this.setTempPagination({
      currentPage: this.currentPage,
      query: this.query,
      queryTemp: this.queryTemp,
      filteredTabStatus: this.filterStatus,
      limit: this.paginationLimit,
      status: true
    });
    next();
  }
};
</script>
